export const inputnumber = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  button: {
    width: "{form.field.icon.size}",
    borderRadius: "{form.field.border.radius}",
    verticalPadding: "{form.field.padding.y}",
  },
  extend: {
    ui: {
      hoverColor: "{primary.support}",
    },
  },
  colorScheme: {
    light: {
      button: {
        background: "transparent",
        hoverBackground: "transparent",
        activeBackground: "transparent",
        borderColor: "{form.field.border.color}",
        hoverBorderColor: "{primary.support}",
        activeBorderColor: "{primary.default}",
        color: "{form.field.icon.color}",
        hoverColor: "{form.field.icon.color}",
        activeColor: "{form.field.icon.color}",
      },
    },
    dark: {
      button: {
        background: "transparent",
        hoverBackground: "transparent",
        activeBackground: "transparent",
        borderColor: "{form.field.border.color}",
        hoverBorderColor: "{primary.support}",
        activeBorderColor: "{primary.default}",
        color: "{form.field.icon.color}",
        hoverColor: "{form.field.icon.color}",
        activeColor: "{form.field.icon.color}",
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-inputnumber-stacked .p-inputnumber-button-group {
      border-inline-start: 1px solid ${dt("inputnumber.button.border.color")};
    }

    .p-inputnumber-stacked .p-inputnumber-decrement-button {
      border-block-start: 1px solid ${dt("inputnumber.button.border.color")};
    }
    
    .p-inputnumber input:enabled:hover {
      border-color: ${dt("inputnumber.extend.ui.hover.color")};
    }

    .p-inputnumber input:focus {
      border-color: ${dt("inputnumber.extend.ui.hover.color")};
    }
    
  `,
};
